import { createFileRoute } from '@tanstack/react-router'
import { StationsPage } from '@/pages/stations'

export const Route = createFileRoute('/_authenticated/stations')({
  component: StationsPage,
})